import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { Http } from '@angular/http';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Toast } from '@ionic-native/toast';
import { TranslateService } from '@ngx-translate/core';
import { NewsDetailPage } from '../news-detail/news-detail';
import { NewsListPage } from '../news-list/news-list';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';



@Component({
  selector: 'page-finance-options',
  templateUrl: 'finance-options.html',
})
export class FinanceOptionsPage {
  @ViewChild(InfiniteScroll) infinite: InfiniteScroll;
  availableFinance = new Array;
  response = new Array;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public http: Http,
    public config: ConfigProvider,
    public loading: LoadingProvider,
    private toast: Toast,
    public shared: SharedDataProvider,
    translate: TranslateService) {

    var dat: { [k: string]: any } = {};
    dat.language_id = this.config.langId;
    dat.is_feature = 1;
    dat.customer_id = this.shared.customerData.customers_id;
    dat.trader_id = this.shared.customerData.traderID;

    console.log("Customer Info:",this.shared.customerData);
    this.http.post(this.config.url + 'traderOptions', dat).map(res => res.json()).subscribe(data => {
      console.log("Got Response:",data);
      this.response = data;
      this.availableFinance = data.FINANCETYPES;

    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/finance-options/finance-options.ts